import Transactions from "./Transactions/Transactions.vue";
import { TransactionsViewModel } from "./Transactions/TransactionsViewModel";
import { CarbucksViewModel } from "./Types/CarbucksViewModel";
import type { ICarbucksViewModel } from "./Types/ICarbucksViewModel";
import { useViewModelInstance } from "./Types/CarbucksViewModelStore";
import { useCarbucksApi } from "./Types/Api/CarbucksApi";

export 
{
    TransactionsViewModel,
    CarbucksViewModel,
    ICarbucksViewModel,
    useViewModelInstance,
    useCarbucksApi
};
 
export default [
    {
        path: '/carbucks',
        name: 'CarbucksProfile',
        meta: {
            allowAnonymous: false, 
            title: 'Carbucks'
        },
        component: () => import( "./Views/CarbucksProfile.vue"),
    },
    {
        path: '/carbucks/transactions/:transactionType?',
        name: 'CarbucksTransactions',
        meta: {
            allowAnonymous: false, 
            title: 'Transactions'
        },
        component: Transactions,
    },
    {
        path: '/carbucks/manage-bank-account',
        name: 'Manage Bank Account',
        meta: {
            allowAnonymous: false,
            title: 'Manage Bank Account'
        },
        component: () => import( './Views/ManageBankAccount.vue' )
    },
    {
        path: '/carbucks/redeem-cashback',
        name: 'Redeem Cashback',
        meta: {
            allowAnonymous: false,
            title: 'Redeem Cashback'
        },
        component: () => import( './Views/RedeemCashback.vue' )
    }
];
